
module dgUtils {
    function camelToDashes(): IStringTransformFilter {
        return (str) => {
            return str.replace(/\W+/g, '-')
                .replace(/([a-z\d])([A-Z])/g, '$1-$2').toLowerCase();
        }
    }
    angular.module('dgUtils')
        .filter('camelToDashes', camelToDashes);
}